import {
  INVEST_PDF_MAX_Y,
  INVEST_PDF_OKRAJ_X,
  INVEST_PDF_SIRKA_OBSAHU,
  novaInvestPdfStrana,
  zabezpecInvestPdfMiesto,
} from "./investPdfPomocne";

import { maVyvojInvesticiePoplatky, vytvorRiadkyVyvojaInvesticie, } from "./investVyvojPomocne";

const FARBA_NADPIS = [120, 102, 67];
const FARBA_TEXT = [45, 45, 45];
const FARBA_JEMNA = [105, 105, 105];
const FARBA_LINKA = [205, 196, 177];
const FARBA_POZADIE = [248, 246, 240];

const POZNAMKA_ROZLOZENIE =
  Object.freeze({
    padding: 4,
    vyskaNadpisu: 8,
    vyskaRiadka: 3.4,
    odsadenieZaBlokom: 5,
  });

const VYVOJ_ROZLOZENIE =
  Object.freeze({
    padding: 4,
    vyskaNadpisu: 8,
    vyskaHlavicky: 8,
    vyskaRiadka: 6,
    vyskaRiadkaSDetailom: 9,
    vyskaSuhrnu: 7,
    odsadenieZaBlokom: 5,
  });

const FORMAT_SUMY =
  new Intl.NumberFormat(
    "sk-SK",
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }
  );

function cislo(hodnota) {
  const vysledok =
    Number(hodnota);

  return Number.isFinite(vysledok)
    ? vysledok
    : 0;
}

function text(hodnota) {
  return String(
    hodnota || ""
  ).trim();
}

function formatujSumu(hodnota) {
  return `${
    FORMAT_SUMY.format(
      cislo(hodnota)
    )
  } €`;
}

function formatujSumuBezDesatin(
  hodnota
) {
  return `${
    cislo(hodnota).toLocaleString(
      "sk-SK",
      {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }
    )
  } €`;
}

function nastavFarbu(
  pdf,
  farba,
  ciel = "text"
) {
  if (ciel === "fill") {
    pdf.setFillColor(...farba);
    return;
  }

  if (ciel === "draw") {
    pdf.setDrawColor(...farba);
    return;
  }

  pdf.setTextColor(...farba);
}

export function pripravInvestPdfPoznamku(
  poznamka
) {
  const hodnota =
    text(poznamka);

  return hodnota
    ? {
        text: hodnota,
      }
    : null;
}

export function maInvestPdfPoznamku(
  poznamka
) {
  return Boolean(
    text(
      poznamka?.text ??
        poznamka
    )
  );
}

export function pripravInvestPdfVyvoj({
  aktivnyInvesticnyVariant,
  porovnanieInvesticii,
  vysledkyInvesticii,
  nastaveniaVariantov,
}) {
  const variant =
    porovnanieInvesticii &&
    Number(
      aktivnyInvesticnyVariant
    ) === 2
      ? 2
      : 1;

  const vysledok =
    variant === 2
      ? vysledkyInvesticii
          ?.variant2
      : vysledkyInvesticii
          ?.variant1;

  const nastavenia =
    variant === 2
      ? nastaveniaVariantov
          ?.variant2
      : nastaveniaVariantov
          ?.variant1;

  const riadky =
    vytvorRiadkyVyvojaInvesticie({
      vysledok,
      nastavenia,
      rezim: "roky",
    });

  const maZakladneData =
    riadky.some(
      (riadok) =>
        cislo(
          riadok?.vklady
        ) > 0 ||
        cislo(
          riadok
            ?.hodnotaInvesticie
        ) > 0
    );

  if (!maZakladneData) {
    return null;
  }

  return {
    variant,
    riadky,

    zobrazitPoplatky:
      maVyvojInvesticiePoplatky(
        riadky
      ),

    zobrazitRealnuHodnotu:
      cislo(
        vysledok?.inflacia
      ) > 0,

    danZVynosu:
      cislo(
        vysledok?.danZVynosu
      ),

    konecnaHodnotaPoDani:
      cislo(
        vysledok
          ?.konecnaHodnotaPoDani
      ),
  };
}

export function maInvestPdfVyvoj(
  vyvojInvesticie
) {
  return Boolean(
    vyvojInvesticie &&
      Array.isArray(
        vyvojInvesticie.riadky
      ) &&
      vyvojInvesticie
        .riadky.length > 0
  );
}

function zapisPoznamkovyBlok(
  pdf,
  stav,
  riadky,
  pokracovanie
) {
  const vyskaBloku =
    POZNAMKA_ROZLOZENIE
      .padding *
      2 +
    POZNAMKA_ROZLOZENIE
      .vyskaNadpisu +
    riadky.length *
      POZNAMKA_ROZLOZENIE
        .vyskaRiadka;

  const x =
    INVEST_PDF_OKRAJ_X;

  const y = stav.y;

  nastavFarbu(
    pdf,
    FARBA_LINKA,
    "draw"
  );

  pdf.setLineWidth(0.35);

  pdf.roundedRect(
    x,
    y,
    INVEST_PDF_SIRKA_OBSAHU,
    vyskaBloku,
    3,
    3,
    "S"
  );

  pdf.setFont(
    "Inter",
    "bold"
  );

  pdf.setFontSize(8.2);

  nastavFarbu(
    pdf,
    FARBA_NADPIS
  );

  pdf.text(
    pokracovanie
      ? "Poznámky - pokračovanie"
      : "Poznámky",
    x +
      POZNAMKA_ROZLOZENIE
        .padding,
    y + 6.2
  );

  pdf.setFont(
    "Inter",
    "normal"
  );

  pdf.setFontSize(7);

  nastavFarbu(
    pdf,
    FARBA_TEXT
  );

  riadky.forEach(
    (riadok, index) => {
      pdf.text(
        riadok,
        x +
          POZNAMKA_ROZLOZENIE
            .padding,
        y +
          POZNAMKA_ROZLOZENIE
            .padding +
          POZNAMKA_ROZLOZENIE
            .vyskaNadpisu +
          2.4 +
          index *
            POZNAMKA_ROZLOZENIE
              .vyskaRiadka
      );
    }
  );

  stav.y +=
    vyskaBloku +
    POZNAMKA_ROZLOZENIE
      .odsadenieZaBlokom;
}

export function zapisInvestPdfPoznamku(
  pdf,
  stav,
  poznamkaPdf
) {
  if (
    !maInvestPdfPoznamku(
      poznamkaPdf
    )
  ) {
    return;
  }

  pdf.setFont(
    "Inter",
    "normal"
  );

  pdf.setFontSize(7);

  const riadky =
    pdf.splitTextToSize(
      poznamkaPdf.text,
      INVEST_PDF_SIRKA_OBSAHU -
        POZNAMKA_ROZLOZENIE
          .padding *
          2
    );

  let index = 0;

  while (
    index < riadky.length
  ) {
    const pevnaVyska =
      POZNAMKA_ROZLOZENIE
        .padding *
        2 +
      POZNAMKA_ROZLOZENIE
        .vyskaNadpisu +
      POZNAMKA_ROZLOZENIE
        .odsadenieZaBlokom;

    let pocetRiadkov =
      Math.floor(
        (
          INVEST_PDF_MAX_Y -
          stav.y -
          pevnaVyska
        ) /
          POZNAMKA_ROZLOZENIE
            .vyskaRiadka
      );

    if (pocetRiadkov < 1) {
      novaInvestPdfStrana(
        pdf,
        stav
      );

      continue;
    }

    pocetRiadkov =
      Math.min(
        pocetRiadkov,
        riadky.length -
          index
      );

    zapisPoznamkovyBlok(
      pdf,
      stav,
      riadky.slice(
        index,
        index + pocetRiadkov
      ),
      index > 0
    );

    index += pocetRiadkov;

    if (
      index < riadky.length
    ) {
      novaInvestPdfStrana(
        pdf,
        stav
      );
    }
  }
}

function sirkyStlpcov(
  zobrazitRealnuHodnotu,
  zobrazitPoplatky
) {
  if (zobrazitPoplatky) {
    return zobrazitRealnuHodnotu
      ? [
          13,
          25,
          24,
          22,
          26,
          31,
          31,
        ]
      : [
          14,
          30,
          28,
          26,
          30,
          44,
        ];
  }

  return zobrazitRealnuHodnotu
    ? [
        16,
        36,
        34,
        43,
        43,
      ]
    : [
        18,
        45,
        43,
        66,
      ];
}

function hlavickyStlpcov(
  zobrazitRealnuHodnotu,
  zobrazitPoplatky
) {
  const hlavicky = [
    "Rok",
    "Vklady",
    "Zhodnotenie",
  ];

  if (zobrazitPoplatky) {
    hlavicky.push(
      "Poplatky",
      "Vplyv poplatkov"
    );
  }

  hlavicky.push(
    "Hodnota investície"
  );

  if (
    zobrazitRealnuHodnotu
  ) {
    hlavicky.push(
      "Reálna hodnota"
    );
  }

  return hlavicky;
}

function maDetailRiadka(
  riadok,
  zobrazitPoplatky
) {
  return (
    cislo(
      riadok?.privklad
    ) > 0 ||
    (
      zobrazitPoplatky &&
      cislo(
        riadok
          ?.externyPoplatok
      ) > 0
    )
  );
}

function vyskaRiadka(
  riadok,
  zobrazitPoplatky
) {
  return maDetailRiadka(
    riadok,
    zobrazitPoplatky
  )
    ? VYVOJ_ROZLOZENIE
        .vyskaRiadkaSDetailom
    : VYVOJ_ROZLOZENIE
        .vyskaRiadka;
}

function zapisBunku(
  pdf,
  hodnota,
  x,
  y,
  sirka,
  zarovnanie = "center"
) {
  const textX =
    zarovnanie === "left"
      ? x + 1.4
      : zarovnanie === "right"
        ? x + sirka - 1.4
        : x + sirka / 2;

  pdf.text(
    hodnota,
    textX,
    y,
    {
      align: zarovnanie,
      maxWidth:
        sirka - 2.8,
    }
  );
}

function zapisHlavickuTabulky(
  pdf,
  x,
  y,
  sirky,
  hlavicky
) {
  nastavFarbu(
    pdf,
    FARBA_POZADIE,
    "fill"
  );

  pdf.rect(
    x,
    y,
    INVEST_PDF_SIRKA_OBSAHU -
      VYVOJ_ROZLOZENIE
        .padding *
        2,
    VYVOJ_ROZLOZENIE
      .vyskaHlavicky,
    "F"
  );

  let stlpecX = x;

  pdf.setFont(
    "Inter",
    "bold"
  );

  pdf.setFontSize(5.7);

  nastavFarbu(
    pdf,
    FARBA_TEXT
  );

  hlavicky.forEach(
    (hlavicka, index) => {
      const riadky =
        pdf.splitTextToSize(
          hlavicka,
          sirky[index] -
            2.8
        );

      const jePrvyStlpec =
        index === 0;

      pdf.text(
        riadky,
        jePrvyStlpec
          ? stlpecX + 1.4
          : stlpecX +
              sirky[index] / 2,
        y + 3.2,
        {
          align:
            jePrvyStlpec
              ? "left"
              : "center",
          lineHeightFactor:
            1.05,
          maxWidth:
            sirky[index] - 2.8,
        }
      );

      stlpecX +=
        sirky[index];
    }
  );
}

function zapisRiadokTabulky(
  pdf,
  riadok,
  x,
  y,
  sirky,
  zobrazitRealnuHodnotu,
  zobrazitPoplatky
) {
  const vyska =
    vyskaRiadka(
      riadok,
      zobrazitPoplatky
    );

  nastavFarbu(
    pdf,
    FARBA_LINKA,
    "draw"
  );

  pdf.setLineWidth(0.12);

  pdf.line(
    x,
    y + vyska,
    x +
      sirky.reduce(
        (
          sucet,
          hodnota
        ) =>
          sucet + hodnota,
        0
      ),
    y + vyska
  );

  pdf.setFont(
    "Inter",
    "normal"
  );

  pdf.setFontSize(5.6);

  nastavFarbu(
    pdf,
    FARBA_TEXT
  );

  let stlpecX = x;
  let indexStlpca = 0;

  zapisBunku(
    pdf,
    `${
      riadok.obdobie
    }${
      riadok
        .jeZaciatokDodatocnehoZhodnocovania
        ? "*"
        : ""
    }`,
    stlpecX,
    y + 3.8,
    sirky[indexStlpca],
    "left"
  );

  stlpecX +=
    sirky[indexStlpca];
  indexStlpca += 1;

  zapisBunku(
    pdf,
    formatujSumu(
      riadok.vklady
    ),
    stlpecX,
    y + 3.8,
    sirky[indexStlpca]
  );

  if (
    cislo(
      riadok.privklad
    ) > 0
  ) {
    pdf.setFontSize(4.8);

    nastavFarbu(
      pdf,
      FARBA_JEMNA
    );

    zapisBunku(
      pdf,
      `(prívklad ${
        formatujSumuBezDesatin(
          riadok.privklad
        )
      })`,
      stlpecX,
      y + 7,
      sirky[indexStlpca]
    );

    pdf.setFontSize(5.6);

    nastavFarbu(
      pdf,
      FARBA_TEXT
    );
  }

  stlpecX +=
    sirky[indexStlpca];
  indexStlpca += 1;

  zapisBunku(
    pdf,
    formatujSumu(
      riadok.zhodnotenie
    ),
    stlpecX,
    y + 3.8,
    sirky[indexStlpca]
  );

  stlpecX +=
    sirky[indexStlpca];
  indexStlpca += 1;

  if (zobrazitPoplatky) {
    zapisBunku(
      pdf,
      formatujSumu(
        riadok.poplatky
      ),
      stlpecX,
      y + 3.8,
      sirky[indexStlpca]
    );

    if (
      cislo(
        riadok
          .externyPoplatok
      ) > 0
    ) {
      pdf.setFontSize(4.8);

      nastavFarbu(
        pdf,
        FARBA_JEMNA
      );

      zapisBunku(
        pdf,
        `mimo investície ${
          formatujSumuBezDesatin(
            riadok
              .externyPoplatok
          )
        }`,
        stlpecX,
        y + 7,
        sirky[indexStlpca]
      );

      pdf.setFontSize(5.6);

      nastavFarbu(
        pdf,
        FARBA_TEXT
      );
    }

    stlpecX +=
      sirky[indexStlpca];
    indexStlpca += 1;

    zapisBunku(
      pdf,
      formatujSumu(
        riadok
          .vplyvPoplatkov
      ),
      stlpecX,
      y + 3.8,
      sirky[indexStlpca]
    );

    stlpecX +=
      sirky[indexStlpca];
    indexStlpca += 1;
  }

  zapisBunku(
    pdf,
    formatujSumu(
      riadok
        .hodnotaInvesticie
    ),
    stlpecX,
    y + 3.8,
    sirky[indexStlpca]
  );

  stlpecX +=
    sirky[indexStlpca];
  indexStlpca += 1;

  if (
    zobrazitRealnuHodnotu
  ) {
    zapisBunku(
      pdf,
      formatujSumu(
        riadok
          .realnaHodnota
      ),
      stlpecX,
      y + 3.8,
      sirky[indexStlpca]
    );
  }

  return vyska;
}

function zistiSuhrn(
  vyvojInvesticie
) {
  const maDodatocneZhodnocovanie =
    vyvojInvesticie
      .riadky.some(
        (riadok) =>
          riadok
            .jeZaciatokDodatocnehoZhodnocovania
      );

  const zobrazitDan =
    cislo(
      vyvojInvesticie
        .danZVynosu
    ) > 0;

  return {
    maDodatocneZhodnocovanie,
    zobrazitDan,

    vyska:
      maDodatocneZhodnocovanie &&
      zobrazitDan
        ? 10
        : maDodatocneZhodnocovanie ||
            zobrazitDan
          ? VYVOJ_ROZLOZENIE
              .vyskaSuhrnu
          : 0,
  };
}

function zapisSuhrn(
  pdf,
  vyvojInvesticie,
  x,
  y,
  suhrn
) {
  pdf.setFontSize(5.2);

  nastavFarbu(
    pdf,
    FARBA_JEMNA
  );

  if (
    suhrn
      .maDodatocneZhodnocovanie
  ) {
    pdf.setFont(
      "Inter",
      "bold"
    );

    pdf.text(
      "*Dodatočné zhodnocovanie bez vkladov",
      x,
      y +
        (
          suhrn.zobrazitDan
            ? 3.5
            : 4.2
        )
    );
  }

  if (suhrn.zobrazitDan) {
    pdf.setFont(
      "Inter",
      "normal"
    );

    const textDane =
      `Odhadovaná daň pri ukončení: ${
        formatujSumu(
          vyvojInvesticie
            .danZVynosu
        )
      }` +
      `   Konečná hodnota po zdanení: ${
        formatujSumu(
          vyvojInvesticie
            .konecnaHodnotaPoDani
        )
      }`;

    pdf.text(
      textDane,
      x +
        INVEST_PDF_SIRKA_OBSAHU -
        VYVOJ_ROZLOZENIE
          .padding *
          2,
      y +
        (
          suhrn
            .maDodatocneZhodnocovanie
            ? 7.4
            : 4.2
        ),
      {
        align: "right",
      }
    );
  }
}

function zistiRiadkySegmentu(
  riadky,
  zaciatok,
  dostupnaVyska,
  vyskaSuhrnu,
  zobrazitPoplatky
) {
  const pevnaVyska =
    VYVOJ_ROZLOZENIE
      .padding *
      2 +
    VYVOJ_ROZLOZENIE
      .vyskaNadpisu +
    VYVOJ_ROZLOZENIE
      .vyskaHlavicky;

  let pouzitaVyska =
    pevnaVyska;

  let koniec = zaciatok;

  while (
    koniec < riadky.length
  ) {
    const dalsiaVyska =
      vyskaRiadka(
        riadky[koniec],
        zobrazitPoplatky
      );

    const jePosledny =
      koniec ===
      riadky.length - 1;

    const rezervovanySuhrn =
      jePosledny
        ? vyskaSuhrnu
        : 0;

    if (
      pouzitaVyska +
        dalsiaVyska +
        rezervovanySuhrn >
      dostupnaVyska
    ) {
      break;
    }

    pouzitaVyska +=
      dalsiaVyska;

    koniec += 1;
  }

  return {
    koniec,
    pouzitaVyska,
  };
}

export function zapisInvestPdfVyvoj(
  pdf,
  stav,
  vyvojInvesticie
) {
  if (
    !maInvestPdfVyvoj(
      vyvojInvesticie
    )
  ) {
    return;
  }

  const zobrazitPoplatky =
    Boolean(
      vyvojInvesticie
        .zobrazitPoplatky
    );

  const suhrn =
    zistiSuhrn(
      vyvojInvesticie
    );

  let zaciatok = 0;

  while (
    zaciatok <
    vyvojInvesticie
      .riadky.length
  ) {
    const minimalnaVyska =
      VYVOJ_ROZLOZENIE
        .padding *
        2 +
      VYVOJ_ROZLOZENIE
        .vyskaNadpisu +
      VYVOJ_ROZLOZENIE
        .vyskaHlavicky +
      VYVOJ_ROZLOZENIE
        .vyskaRiadka +
      VYVOJ_ROZLOZENIE
        .odsadenieZaBlokom;

    zabezpecInvestPdfMiesto(
      pdf,
      stav,
      minimalnaVyska
    );

    const dostupnaVyska =
      INVEST_PDF_MAX_Y -
      stav.y -
      VYVOJ_ROZLOZENIE
        .odsadenieZaBlokom;

    const segment =
      zistiRiadkySegmentu(
        vyvojInvesticie
          .riadky,
        zaciatok,
        dostupnaVyska,
        suhrn.vyska,
        zobrazitPoplatky
      );

    if (
      segment.koniec ===
      zaciatok
    ) {
      novaInvestPdfStrana(
        pdf,
        stav
      );

      continue;
    }

    const jePoslednySegment =
      segment.koniec ===
      vyvojInvesticie
        .riadky.length;

    const vyskaSuhrnu =
      jePoslednySegment
        ? suhrn.vyska
        : 0;

    const vyskaBloku =
      segment.pouzitaVyska +
      vyskaSuhrnu;

    const x =
      INVEST_PDF_OKRAJ_X;

    const y = stav.y;

    nastavFarbu(
      pdf,
      FARBA_LINKA,
      "draw"
    );

    pdf.setLineWidth(0.35);

    pdf.roundedRect(
      x,
      y,
      INVEST_PDF_SIRKA_OBSAHU,
      vyskaBloku,
      3,
      3,
      "S"
    );

    pdf.setFont(
      "Inter",
      "bold"
    );

    pdf.setFontSize(8.2);

    nastavFarbu(
      pdf,
      FARBA_NADPIS
    );

    pdf.text(
      zaciatok === 0
        ? "Vývoj investície"
        : "Vývoj investície - pokračovanie",
      x +
        VYVOJ_ROZLOZENIE
          .padding,
      y + 6.2
    );

    pdf.setFont(
      "Inter",
      "normal"
    );

    pdf.setFontSize(6.2);

    nastavFarbu(
      pdf,
      FARBA_JEMNA
    );

    pdf.text(
      `Variant ${
        vyvojInvesticie.variant
      }`,
      x +
        INVEST_PDF_SIRKA_OBSAHU -
        VYVOJ_ROZLOZENIE
          .padding,
      y + 6.2,
      {
        align: "right",
      }
    );

    const sirky =
      sirkyStlpcov(
        vyvojInvesticie
          .zobrazitRealnuHodnotu,
        zobrazitPoplatky
      );

    const hlavicky =
      hlavickyStlpcov(
        vyvojInvesticie
          .zobrazitRealnuHodnotu,
        zobrazitPoplatky
      );

    const tabulkaX =
      x +
      VYVOJ_ROZLOZENIE
        .padding;

    let tabulkaY =
      y +
      VYVOJ_ROZLOZENIE
        .padding +
      VYVOJ_ROZLOZENIE
        .vyskaNadpisu;

    zapisHlavickuTabulky(
      pdf,
      tabulkaX,
      tabulkaY,
      sirky,
      hlavicky
    );

    tabulkaY +=
      VYVOJ_ROZLOZENIE
        .vyskaHlavicky;

    vyvojInvesticie
      .riadky
      .slice(
        zaciatok,
        segment.koniec
      )
      .forEach(
        (riadok) => {
          tabulkaY +=
            zapisRiadokTabulky(
              pdf,
              riadok,
              tabulkaX,
              tabulkaY,
              sirky,
              vyvojInvesticie
                .zobrazitRealnuHodnotu,
              zobrazitPoplatky
            );
        }
      );

    if (
      jePoslednySegment &&
      suhrn.vyska > 0
    ) {
      zapisSuhrn(
        pdf,
        vyvojInvesticie,
        tabulkaX,
        tabulkaY,
        suhrn
      );
    }

    stav.y +=
      vyskaBloku +
      VYVOJ_ROZLOZENIE
        .odsadenieZaBlokom;

    zaciatok =
      segment.koniec;

    if (
      zaciatok <
      vyvojInvesticie
        .riadky.length
    ) {
      novaInvestPdfStrana(
        pdf,
        stav
      );
    }
  }
}